import _, { partial } from 'lodash';
import {
  AppConfigs,
  AppData,
  UserData,
  UserMetaData,
} from '../../redux/auth/authTypes';

// #region user ls
let userMetaDataLSKey = 'userMetaData';
export const saveUserMetaDataLS = (user: UserData) => {
  const useMetaData: UserMetaData = {
    id: user.id,
    email: user.email,
    username: user.username,
    fullname: user.fullname,
  };
  localStorage.setItem(userMetaDataLSKey, JSON.stringify(useMetaData));
};

const MANUAL_MODE_KEY = 'M_M';
export const saveManualModeToggle = (userId: string | undefined) =>{
  userId
    ? localStorage.setItem(MANUAL_MODE_KEY, userId)
    : localStorage.removeItem(MANUAL_MODE_KEY);
}

export const getManualModeState = (userId: string) => {
  const id = localStorage.getItem(MANUAL_MODE_KEY);


  return id === userId;
};

export const getUserMetaDataLS = () => {
  const user = localStorage.getItem(userMetaDataLSKey);
  return user ? JSON.parse(user) : null;
};

export const removeUserMetaDataLS = () =>
  localStorage.removeItem(userMetaDataLSKey);
// #endregion

// #region app ls
let appConfigsKey = 'appConfigs';
export const saveAppConfigsLS = (data: AppData) => {
  let app: AppConfigs = {
    localBackups: data.localBackups,
    primaryStorage: data.primaryStorage,
    backupFrequency: data.backupFrequency,
  };

  localStorage.setItem(appConfigsKey, JSON.stringify(app));
};

export const getAppConfigsLS = (): AppConfigs => {
  const configs = localStorage.getItem(appConfigsKey);

  return configs ? JSON.parse(configs) : null;
};
// #endregion
